import PropTypes from "prop-types";
import { isEmpty } from "lodash";

import styles from "./showFields.module.css";
import { previewText } from "../../helpers/cellPreview";

function Email({ value, options = {} }) {
  return !isEmpty(value) ? (
    <a
      className={styles.Email}
      href={`mailto:${value}`}
      title={value}
      target="_blank"
      rel="nofollow noopener noreferrer"
    >
      {options.truncate ? previewText(value) : value}
    </a>
  ) : (
    <span className={styles.Email} />
  );
}
Email.propTypes = {
  value: PropTypes.string,
  options: PropTypes.shape({ truncate: PropTypes.bool }),
};

export default Email;
